import {
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useGoKredytService } from '../utils/axios';

export default function CreditMatrix() {

  const goKredytService = useGoKredytService();
  const [loading, setLoading] = useState(false);
  const [criteriaEntries, setCriteriaEntries] = useState([]);


  useEffect(() => {
    reload();
  }, []);

  function reload() {
    setLoading(true);
    goKredytService.get('/admin/criteria').then(
      res => {
        setCriteriaEntries(res.data);
        setLoading(false);
      }
    ).catch(() => setLoading(false));
  }

  const saveChanges = async () => {
    try {
      setLoading(true);
      await goKredytService.post('/admin/criteria', criteriaEntries);
      setLoading(false);
      reload();
    } catch (error) {
      alert('Error saving changes');
      console.error(error);
      setLoading(false);
    }
  };


  return (
    <>
      <Typography variant="h2" gutterBottom>
        Matryca kredytu
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={saveChanges}
        style={{ marginTop: '20px' }}
        disabled={loading}
      >
        {loading ? <CircularProgress size={24} /> : 'Zapisz'}
      </Button>
      <TableContainer>
        <Table className="creditMatrix">
          <TableHead>
            <TableRow>
              <TableCell colSpan={2} align="center">
                Okres kredytu w miesiącach
              </TableCell>
              <TableCell colSpan={2} align="center">
                Wartości kredytu
              </TableCell>
              <TableCell colSpan={16} align="center">
                Oprocentowanie
              </TableCell>
              <TableCell colSpan={2} align="center">
                Prowizja
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Od</TableCell>
              <TableCell>Do</TableCell>
              <TableCell>Minimalna wartość samochodu</TableCell>
              <TableCell>Maksymalna wartość samochodu</TableCell>
              <TableCell>Wiek samochodu - 0 lat</TableCell>
              <TableCell>Wiek samochodu - 1 rok</TableCell>
              <TableCell>Wiek samochodu - 2 lata</TableCell>
              <TableCell>Wiek samochodu - 3 lata</TableCell>
              <TableCell>Wiek samochodu - 4 lata</TableCell>
              <TableCell>Wiek samochodu - 5 lat</TableCell>
              <TableCell>Wiek samochodu - 6 lat</TableCell>
              <TableCell>Wiek samochodu - 7 lat</TableCell>
              <TableCell>Wiek samochodu - 8 lat</TableCell>
              <TableCell>Wiek samochodu - 9 lat</TableCell>
              <TableCell>Wiek samochodu - 10 lat</TableCell>
              <TableCell>Wiek samochodu - 11 lat</TableCell>
              <TableCell>Wiek samochodu - 12 lat</TableCell>
              <TableCell>Wiek samochodu - 13 lat</TableCell>
              <TableCell>Wiek samochodu - 14 lat</TableCell>
              <TableCell>Wiek samochodu - 15 lat</TableCell>
              <TableCell>Prowizja GO-Leasing</TableCell>
              <TableCell>Prowizja Banku</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={22} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : (
              criteriaEntries.map((entry, index) => (
                <TableRow key={index}>
                  {Object.keys(entry).map((key) => (
                    <TableCell key={key}>
                      <TextField
                        value={entry[key] || ''}
                        onChange={(e) => {
                          const newEntries = [...criteriaEntries];
                          newEntries[index][key] = e.target.value === '' ? null : parseFloat(e.target.value);
                          setCriteriaEntries(newEntries);
                        }}
                      />
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

    </>
  );
}
